export const OPEN_AI_SUPPORTED_MARKING_INTRO = 'aiSupportedMarkingIntro/OPEN';
export const CLOSE_AI_SUPPORTED_MARKING_INTRO = 'aiSupportedMarkingIntro/CLOSE';
export const SET_DONT_SHOW_AGAIN = 'aiSupportedMarkingIntro/SET_DONT_SHOW_AGAIN';

export interface OpenAiSupportedMarkingIntroAction {
    type: typeof OPEN_AI_SUPPORTED_MARKING_INTRO;
    payload: {
        pendingWorkspaceId: string;
        userId?: number;
        assessmentRunId?: number;
    };
}

export interface CloseAiSupportedMarkingIntroAction {
    type: typeof CLOSE_AI_SUPPORTED_MARKING_INTRO;
}

export interface SetDontShowAgainAction {
    type: typeof SET_DONT_SHOW_AGAIN;
    payload: {
        value: boolean;
        userId?: number;
        assessmentRunId?: number;
    };
}

export const openAiSupportedMarkingIntro = (
    pendingWorkspaceId: string,
    userId?: number,
    assessmentRunId?: number,
): OpenAiSupportedMarkingIntroAction => ({
    type: OPEN_AI_SUPPORTED_MARKING_INTRO,
    payload: { pendingWorkspaceId, userId, assessmentRunId },
});

export const closeAiSupportedMarkingIntro = (): CloseAiSupportedMarkingIntroAction => ({
    type: CLOSE_AI_SUPPORTED_MARKING_INTRO,
});

export const setDontShowAgain = (
    value: boolean,
    userId?: number,
    assessmentRunId?: number,
): SetDontShowAgainAction => ({
    type: SET_DONT_SHOW_AGAIN,
    payload: { value, userId, assessmentRunId },
});

export type AiSupportedMarkingIntroActions =
    | OpenAiSupportedMarkingIntroAction
    | CloseAiSupportedMarkingIntroAction
    | SetDontShowAgainAction;
